<template>
  <div class="page">
   <div class="bg-white " style="position: relative;">
    <el-button v-if="method != 'add'" size="medium" class="mb8"  :icon="method == 'view' ? 'el-icon-edit' : ''" :type="method == 'view' ? 'warning' :'primary'"  :plain="method == 'view' ? false : true"  @click="handEditorView(method)" :disabled="!hasPermission('unmarticle:cecUnmArticle:edit')">{{ method == 'view' ? '编辑' : '取消'}}</el-button>
    <div :class="method==='view' ? 'opacity7' : ''">
    <el-form :model="inputForm" size="small" ref="inputForm" :rules="rules" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="100px">
      <el-row  :gutter="15" type="flex" style="flex-wrap:wrap">
        <el-col :span="16">
          <el-row  :gutter="15">
            <el-col :span="8">
                <el-form-item label="排序" prop="sort">
                  <el-input v-model="inputForm.sort" placeholder="请填写排序"     ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="状态" prop="state">
                    <!-- <el-select v-model="inputForm.state" placeholder="请选择"  style="width: 100%;">
                              <el-option
                                v-for="item in stateOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                          </el-select> -->
                  <StateSelect v-model="inputForm.state" :option="stateOption" @searchChange="handSelect"></StateSelect>
              </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="创建时间" prop="createDate">
                    <el-date-picker
                      v-model="inputForm.createDate"
                      type="datetime"
                      placeholder="选择日期时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerOptions">
                    </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="英文标题" prop="titleEn">
                  <el-input v-model="inputForm.titleEn" placeholder="请填写英文标题"  maxlength="250"   ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="中文标题" prop="titleCn">
                  <el-input  v-model="inputForm.titleCn" placeholder="请填写中文标题"  maxlength="250"   ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="标签" prop="">
                <tagSelect ref="tagSelectRef" :value="inputForm.tagsIds" @searchChange="handTagSelect" associationType="2"></tagSelect>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
            <el-form-item label="主图" prop="cover">
	      <image-upload-new v-model="inputForm.cover" :disabled="method==='view'" :limit="1" tip="最多上传1个图片,单个图片不要超过10M" @change="handUpload"></image-upload-new>
           </el-form-item>
        </el-col>
        
        <el-col :span="24">
            <el-form-item label="英文内容" prop="contentEn">
              <div style="">
                <div v-if="method === 'view'" class="boxHtml disabled-div">
                  <p v-html="$utils.unescapeHTML(inputForm.contentEn)"></p>
                </div>
                <div v-else style="width:100%">
                  <WangEditor   ref="contentEnEditor1" idNum="1" :maxSize="uploadVideoSize"  :contentHtml="inputForm.contentEn" />
                </div>
              </div>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="中文内容" prop="contentCn">
            <div style="">
              <div v-if="method === 'view'" class="boxHtml disabled-div">
                <p v-html="$utils.unescapeHTML(inputForm.contentCn)"></p>
              </div>
              <div v-else >
                <WangEditor  ref="contentCnEditor2" idNum="2" :maxSize="uploadVideoSize" :contentHtml="inputForm.contentCn" />
              </div>
            </div>
           </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
            <el-form-item label="作者" prop="author"
                :rules="[
                 ]">
              <el-input v-model="inputForm.author" placeholder="请填写作者"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
            <el-form-item label="链接或路由" prop="url"
                :rules="[
                 ]">
              <el-input v-model="inputForm.url" placeholder="请填写链接或路由"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col> -->
        </el-row>
    </el-form>
    <div class="clear"></div>
  </div>
    <div  class="footer">
      <el-button type="danger" size="medium" icon="el-icon-close" @click="closeSelectedTag()">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </div>
  </div>
</div>
</template>

<script>
  import WangEditor from '@/components/editor/WangEditor5'
  import cecUnmArticleService from '@/api/unmarticle/cecUnmArticleService'
  import ImageUploadNew from '@/components/upload/ImageUploadNoAddIon'
  import tags from '@/components/tags'
  import StateSelect from '@/components/select'
  import tagSelect from '@/components/select/tagSelect'
  export default {
    data () {
      var validateContentEn = (rule, value, callback) => {
        if (value === '<p><br></p>') {
          callback(new Error('英文内容不能为空'))
        } else {
          callback()
        }
      }
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          sort: '',
          state: '',
          titleEn: '',
          titleCn: '',
          contentEn: '',
          contentCn: '',
          author: '',
          url: '',
          cover: '',
          tags: '',
          // tagsList: [],
          createDate: '',
          tagsIds: ''
        },
        stateOption: [
          { value: '0', label: '上线' },
          { value: '2', label: '草稿' },
          { value: '1', label: '下线' }
        ],
        tagList: [],
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
        rules: {
          sort: [
            { required: true, message: '排序不能为空', trigger: 'blur' }
          ],
          state: [
            { required: true, message: '状态不能为空', trigger: 'blur' }
          ],
          createDate: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          titleEn: [
            { required: true, message: '英文标题值不能为空', trigger: 'blur' }
          ],
          cover: [
            { required: true, message: '主图不能为空', trigger: 'blur' }
          ],
          contentEn: [
            { required: true, message: '英文内容不能为空', trigger: 'blur' },
            { validator: validateContentEn, trigger: 'blur' }
          ]
        },
        uploadVideoSize: 100
      }
    },
    components: {
      WangEditor,
      ImageUploadNew,
      tags,
      StateSelect,
      tagSelect
    },
    activated () {
      this.init(this.$route.query.type, this.$route.query.id)
      this.getSysConfig()
    },
    methods: {
      getSysConfig () {
        let uploadSize = localStorage.getItem('uploadVideoSize')
        this.uploadVideoSize = Number(uploadSize)
      },
      handTagSelect (e) {
        this.inputForm.tagsIds = e ? e.join(',') : ''
      },
      handSelect (e) {
        this.inputForm.state = e
      },
      getTextContent (data, type) {
        this.inputForm[type] = data
      },
      // 获取上传路径
      handUpload (e) {
        console.log(e)
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
        if (this.method === 'edit') { // 修改或者查看
          this.$nextTick(() => {
            // this.$refs.contentEnEditor.init(this.inputForm.contentEn)
            // this.$refs.contentCnEditor.init(this.inputForm.contentCn)
          })
        }
      },
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建文章管理`
        } else if (method === 'edit') {
          this.title = '修改文章管理'
        } else if (method === 'view') {
          this.title = '查看文章管理'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.tagSelectRef.getTagCloud()
          this.$refs.inputForm.resetFields()
          if (method === 'add') {
            // this.$refs.contentEnEditor.init('')
            // this.$refs.contentCnEditor.init('')
          }
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            this.getDetail()
          }
        })
      },
      getDetail () {
        cecUnmArticleService.queryById(this.inputForm.id).then(({data}) => {
          this.inputForm = this.recover(this.inputForm, data)
          if (data.tagsIds && data.tagsIds !== '') {
            this.inputForm.tags = data.tagsIds.split(',')
          }
          // this.inputForm.tagsList = data.tags ? data.tags.split(',') : []
          // this.$refs.contentEnEditor.init(this.inputForm.contentEn)
          // this.$refs.contentCnEditor.init(this.inputForm.contentCn)
          this.loading = false
        })
      },
      // 表单提交
      doSubmit () {
        this.inputForm.contentEn = this.$refs.contentEnEditor1.editor.getHtml()
        this.inputForm.contentCn = this.$refs.contentCnEditor2.editor.getHtml()
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmArticleService.save(this.inputForm).then(({data}) => {
              if (data.state === '200') {
                this.visible = false
                this.$message.success(data.msg)
                this.getDetail()
              } else {
                this.$message.error('保存失败,' + data.msg)
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      },
      toLastView (visitedViews, view) {
        const latestView = visitedViews.slice(-1)[0]
        if (latestView) {
          this.$router.push(latestView.fullPath)
        } else {
          // now the default is to redirect to the home page if there is no tags-view,
          // you can adjust it according to your needs.
          if (view.name === 'Dashboard') {
            // to reload home page
            this.$router.replace({ path: '/redirect' + view.fullPath })
          } else {
            this.$router.push('/')
          }
        }
      },
      closeSelectedTag () {
        let view = {
          path: '/unmarticle/CecUnmArticleDetail',
          name: 'CecUnmArticleDetail',
          title: '文章详情',
          fullPath: this.$route.fullPath
        }
        this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
          this.toLastView(visitedViews, view)
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
.boxHtml{
  height: 500px;
  overflow-y: auto;
  border: 1px solid #8f8f8f;
  padding: 0 10px;
}
.footer{
    text-align: right;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 20px;
    padding: 10px 20px 0px 20px;
    background: rgb(255, 255, 255);
    display: block;
    z-index: 1000;
    /* user-select: none; */
    border-top: 1px solid rgb(228, 231, 237);
    height: 60px;
}
.clear{
  width: 100%;
  height: 60px;
}
.disabled-div {
  opacity: 0.6;  /* 通常还会降低透明度来表明该div不可交互 */
  pointer-events: auto;
  cursor: not-allowed;
}
.opacity7{
  opacity: 0.7;
}
</style>
  
